<template>
  <b-modal
    :id="modalID"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    size="xl"
    :title="modalTitle"
  >
    <template #default>
      <alert-error
        v-if="form.errors.get('message')"
        :form="form"
        :message="form.errors.get('message')"
      ></alert-error>
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <div class="row d-flex justify-content-center align-items-center">
          <div class="col-md-10 col-lg-8 mt-n1 mt-lg-0">
            <div class="form-group">
              <label for="chantier">Chantiers </label>
              <multiselect
                id="chantier"
                v-model="selectedChantiers"
                :options="chantiers"
                :multiple="true"
                :hideSelected="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                selectLabel="Tapez Entrez pour selectionner"
                placeholder="Choisir les chantiers"
                label="nom"
                track-by="id"
                :disabled="allChantiers"
              >
                <template slot="option" slot-scope="{ option }">
                  <div class="d-flex flex-column mb-2">
                    <span class="h6 font-weight-bold mb-1">
                      {{ option.nom }}
                    </span>
                  </div>
                </template>
              </multiselect>
              <input
                type="hidden"
                class="form-control"
                :class="{
                  'is-invalid': form.errors.has('chantiers'),
                }"
              />
              <has-error :form="form" field="chantiers"></has-error>
            </div>
          </div>

          <div class="col-md-2 col-lg-4 mt-n1 mt-lg-0">
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                id="allChantiers"
                v-model="allChantiers"
              />
              <label class="custom-control-label" for="allChantiers"
                >Tous les chantiers</label
              >
            </div>
          </div>
        </div>
      </form>
    </template>
    <template #modal-footer>
      <button type="button" class="btn btn-danger mr-2" @click="hideModal">
        Fermer
      </button>

      <button
        type="submit"
        class="btn btn-custom-primary w-40"
        @click="submit"
        style="min-width: 100px"
      >
        Valider
      </button>
    </template>
  </b-modal>
</template>

<script>
// import DatePicker from 'vue2-datepicker';
import { mapGetters } from 'vuex';

export default {
  props: {
    propForm: {
      type: Object,
      required: true,
    },
    modalID: {
      type: String,
      required: true,
    },
    modalTitle: {
      type: String,
      required: true,
    },
    chantiers: {
      type: Array,
      default() {
        return [];
      },
    },
    selectedChants: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      form: null,
      selectedChantiers: [],
      allChantiers: false,
    };
  },
  components: {
    // DatePicker,
  },

  methods: {
    /**
     * Modal note
     */
    reset() {
      (this.selectedChantiers = []),
        (this.allChantiers = this.currentRemplacement
          ? Boolean(this.currentRemplacement.header.all_chantiers)
          : false);
    },
    init() {
      this.form = this.propForm;
      this.reset();
    },
    submit() {
      if (!this.allChantiers && this.selectedChantiers.length > 0) {
        this.form.chantiers = this.selectedChantiers.map((c) => c.uuid);
      }
      this.form.all = this.allChantiers;
      this.$emit('submit', this.form);
    },
    hideModal() {
      this.$bvModal.hide(this.modalID);
      this.reset();
      this.$emit('closeModal');
    },
  },
  computed: {
    ...mapGetters('remplacement', ['currentRemplacement']),
  },

  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
